<div class="d-flex"><div class="text-ellipsis">{{params.value}}</div><div *ngIf="params?.data?.info" class="ml-1 d-flex align-items-center"><i class="pi pi-info-circle" [mazarsTooltip]="params.data.info" [escape]="false"></i></div></div>
